import React from "react";
import { useNavigate } from "react-router-dom";
import "./TourTypeViewMore.css";

import ttvsolo from "../../assets/ttvsolo.png";
import ttvgroup from "../../assets/ttvgroup.png";
import ttvfamily from "../../assets/ttvfamily.png";
import ttvbackpacking from "../../assets/ttvbackpacking.png";
import ttvbeach from "../../assets/ttvbeach.png";
import ttvadventure from "../../assets/ttvadventure.png";
import ttvcorporate from "../../assets/ttvcorporate.png";
import ttvhill from "../../assets/ttvhill.png";
import ttvhoneymoon from "../../assets/ttvhoneymoon.png";
import ttvluxury from "../../assets/ttvluxury.png";
import ttvroad from "../../assets/ttvroad.png";
import ttvweekend from "../../assets/ttvweekend.png";
import ttvwild from "../../assets/ttvwild.png";
import ttvspiritual from "../../assets/ttvspiritual.png";
import ttvfestival from "../../assets/ttvfestival.png";
import ttvcouple from "../../assets/ttvcouple.png";

const tripTypes = [
  {
    img: ttvsolo,
    name: "Solo Trip",
    desc: "Travel alone explore yourself freedom growth adventure peace self discovery",
    link: "/solo-trip",
  },
  {
    img: ttvfamily,
    name: "Family Trip",
    desc: "Fun bonding time kids elders memories laughter games sightseeing together",
    link: "/family-trip",
  },
  {
    img: ttvgroup,
    name: "Group Trip",
    desc: "Friends together parties roadtrips fun photos music adventure unforgettable memories",
    link: "/group-trip",
  },
  {
    img: ttvhoneymoon,
    name: "Honeymoon Trip",
    desc: "Romantic escapes candle dinners beaches resorts privacy love beautiful moments",
    link: "/honeymoon-trip",
  },
  {
    img: ttvadventure,
    name: "Adventure Trip",
    desc: "Trekking rafting camping biking mountains thrill adrenaline outdoor challenges",
    link: "/adventure-trip",
  },
  {
    img: ttvluxury,
    name: "Luxury Trip",
    desc: "Premium hotels private transfers comfort spa fine dining exclusive experiences",
    link: "/luxury-trip",
  },
  {
    img: ttvweekend,
    name: "Weekend Getaway",
    desc: "Short breaks quick travel relax recharge explore nearby destinations fun",
    link: "/weekend-getaway-trip",
  },
  {
    img: ttvroad,
    name: "Road Trip",
    desc: "Drive highways music snacks scenic stops freedom friends endless stories",
    link: "/road-trip",
  },
  {
    img: ttvbackpacking,
    name: "Backpacking Trip",
    desc: "Budget stays hostels public transport culture food local adventures",
    link: "/backpacking-trip",
  },
  {
    img: ttvspiritual,
    name: "Religious Trip",
    desc: "Temples meditation yoga peace rituals prayers faith healing soulful journey",
    link: "/religious-trip",
  },
  {
    img: ttvwild,
    name: "Wildlife Safari",
    desc: "Forests animals photography jeep safari nature birds thrilling sightings",
    link: "/wildlife-safari-trip",
  },
  {
    img: ttvbeach,
    name: "Beach Holiday",
    desc: "Sun sand waves resorts seafood sunsets relaxation recognizing coastal beauty",
    link: "/beach-trip",
  },
  {
    img: ttvhill,
    name: "Hill Station Trip",
    desc: "Cool weather mountains valleys waterfalls walks cozy cafes peaceful views",
    link: "/hill-trip",
  },
  {
    img: ttvcorporate,
    name: "Corporate Trip",
    desc: "Team outings meetings workshops bonding fun activities retreats productivity",
    link: "/corporate-trip",
  },
  {
    img: ttvcouple,
    name: "Couple Trip",
    desc: "Romantic strolls cafes sunsets conversations bonding memories cozy evenings",
    link: "/couple-trip",
  },
  {
    img: ttvfestival,
    name: "Festival Trip",
    desc: "Celebrate local festivals colors dances food music traditions cultural immersion",
    link: "/festival-trip",
  },
];

const TourTypeViewMore = () => {
  const navigate = useNavigate();

  return (
    <div className="trip-main-tour">
      <h1 className="trip-title">Choose Your Trip Type</h1>

      <div className="trip-grid-tour">
        {tripTypes.map((item, index) => (
          <div
            key={index}
            className="trip-card-tour"
            onClick={() => navigate(item.link)} 
          >
            <img src={item.img} alt={item.name} />

            <div className="trip-info-tour">
              <h3>{item.name}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TourTypeViewMore;
